import subscriptionRestrictedDictionary from '@pages/subscription-restricted/i18n/ru/subscription-restricted.dic.json';

import chooseProductDictionary from '@features/choose-product/i18n/ru/choose-product.dic.json';
import otherProductsDictionary from '@features/main-banners/i18n/other-products.dic.json';

export const mainPage = {
  CHOOSE_PRODUCT: chooseProductDictionary,
  OTHER_PRODUCTS: otherProductsDictionary,
  SUBSCRIPTION_RESTRICTED: subscriptionRestrictedDictionary,
};

export const mainPageNamespaces = Object.keys(mainPage);
